// Vendor imports
const { connect } = require('react-redux')
// Client V1 imports
const { track } = require('client/lib/analytics')
// Container imports
const TopCallToActionExplainerApp = require('./explainer-app-dumb')

function mapStateToProps(state) {
  const { browser, deeplinkUrls, nativeEmbedded } = state.env
  let androidHref
  let iosHref
  if (!browser.get('native') && !nativeEmbedded) {
    if (browser.get('android')) {
      androidHref = deeplinkUrls.get('android')
    }
    if (browser.get('ios')) {
      iosHref = deeplinkUrls.get('ios')
    }
  }
  return {
    androidHref,
    iosHref,
    onAndroidHrefClick,
    onIosHrefClick
  }
}

module.exports = connect(
  mapStateToProps
)(
  TopCallToActionExplainerApp
)

function onAndroidHrefClick() {
  track('app-download', { platform: 'android' })
}

function onIosHrefClick() {
  track('app-download', { platform: 'ios' })
}
